import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notificationTypes: [],
  allNotifUsers: [],
  allUsers: [],
  toggle: false
};

const sellerNotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    reset: (state) => {
      state.toggle = false
      state.allNotifUsers = []
      state.allUsers = []
    },
    setSellerNotificationTypes: (state, action) => {
      state.notificationTypes = [
        {
          notification_type_en: "Any notifications",
          notification_type_fr: "Any notifications",
          notification_type_id: "ALL",
        },
        ...action.payload.data.notifications,
      ];
    },
    getSellerNotificationTypes: () => {},
    setSellerNotificationAllUsers: (state, action) => {
      state.allNotifUsers = action.payload.data.data;
      state.toggle = true
    },
    getSellerNotificationAllUsers: () => {},
    putSellerNotificationUserData: () => {},
    getPostSellerNotificationUser: () => {},
    getPostSellerUserForNotif: () => {},
    setPostSellerUserForNotif: (state, action) => {
      state.allUsers = action.payload.data.data
    },
    resetInputFormUser: (state) => {
      state.allUsers = []
    }
  },
});

export const {
  setSellerNotificationTypes,
  getSellerNotificationTypes,
  getSellerNotificationAllUsers,
  setSellerNotificationAllUsers,
  putSellerNotificationUserData,
  getPostSellerNotificationUser,
  getPostSellerUserForNotif,
  setPostSellerUserForNotif,
  resetInputFormUser,
  reset
} = sellerNotificationSlice.actions;
export default sellerNotificationSlice.reducer;